import { gql } from 'graphql-tag';

export const QUERY_PRODUCT = gql`
  query GetProduct($id: ID!) {
    product(id: $id) {
      id
      databaseId
      name
      ... on SimpleProduct {
        regularPrice(format: RAW)
        averageRating
        reviewCount
      }
      ... on Product {
        description
        reviews {
          edges {
            rating
            node {
              id
              content
              author {
                node {
                  name
                }
              }
              date
            }
          }
        }
        productCategories {
          edges {
            node {
              name
            }
          }
        }
        image {
          sourceUrl
        }
        galleryImages {
          edges {
            node {
              sourceUrl
              title
            }
          }
        }
      }
    }
  }
`;

export const MUTATION_WRITE_REVIEW = gql`
  mutation WriteReview($input: WriteReviewInput!) {
    writeReview(input: $input) {
      rating
      clientMutationId
    }
  }
`;

export const QUERY_PRODUCTS = gql`
  query AllProducts(
    $items: Int!
    $after: String
    $tags: [String!]
    $search: String
    $maxPrice: Float
    $categoryIn: [String]
    $rating: [Int]
    $onSale: Boolean
    $featured: Boolean
    $stockStatus: [StockStatusEnum]
    $orderby: [ProductsOrderbyInput]
    $brands: [String!]
  ) {
    products(
      first: $items
      after: $after
      where: { 
        tagIn: $tags
        search: $search
        maxPrice: $maxPrice
        categoryIn: $categoryIn
        rating: $rating
        onSale: $onSale
        featured: $featured
        stockStatus: $stockStatus
        orderby: $orderby
        taxonomyFilter: {
          filters: [
            { taxonomy: PA_PABRAND, terms: $brands }
          ]
        }
      }
    ) {
      edges {
        node {
          id
          databaseId
          name
          ... on SimpleProduct {
            regularPrice(format: RAW)
          }
          ... on Product{
            productTags {
              edges {
                node {
                  name
                }
              }
            }
            productCategories {
              edges {
                node {
                  name
                }
              }
            }
            image {
              sourceUrl
              thumbnail: sourceUrl(size: THUMBNAIL)
            }
            galleryImages {
              edges {
                node {
                  sourceUrl
                  title
                }
              }
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

export const QUERY_RECOMMENDED_PRODUCTS = gql`
  query RecommendedProducts($excludeId: Int!) {
    products(
      first: 3,
      after: "",
      where: { exclude: $excludeId }
    ) {
      edges {
        node {
          id
          databaseId
          name
          ... on SimpleProduct {
            regularPrice(format: RAW)
          }
          ... on Product{
            productCategories {
              edges {
                node {
                  name
                }
              }
            }
            image {
              sourceUrl
            }
            galleryImages {
              edges {
                node {
                  sourceUrl
                  title
                }
              }
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

export const QUERY_HOME_PRODUCTS = gql`
  query HomeProducts($tags: [String!]) {
    products(
      first: 4
      where: { 
        tagIn: $tags
        featured: true
      }
    ) {
      edges {
        node {
          id
          databaseId
          name
          ... on SimpleProduct {
            regularPrice(format: RAW)
          }
          ... on Product{
            image {
              sourceUrl
            }
            reviews {
              edges {
                node {
                  content
                  author {
                    node {
                      name
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const QUERY_HOME_CATEGORIES = gql`
  query HomeCategories {
    productCategories(first: 3, where: { hideEmpty: true, parent: 0 }) {
      edges {
        node {
          id
          name
          slug
          image {
            sourceUrl
          }
        }
      }
    }
  }
`;

export const QUERY_HOME_BRANDS = gql`
  query HomeBrands($tags: [String!]) {
    allPaPabrand(first: 20) {
      edges {
        node {
          id
          databaseId
          name
          slug
          products(where: { tagIn: $tags }, first: 1) {
            edges {
              node {
                ... on Product {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
`;
